import React from 'react';
import {Image} from '@themesberg/react-bootstrap';
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import PropTypes from "prop-types";


class PostProcess extends React.Component{
    state = {

    }
    constructor(props) {
        super(props);
        let state = this.state
        state.show = false ;
        this.setState(state)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(this.props!=nextProps){
            let {show} = nextProps
            this.setState({show})
        }
    }

    present(){
        this.setState({show:true})
    }

    dismiss(){
        this.setState({show:false})
    }

    render() {
        let {show} = this.state
        return (
            show?
            <div style={{backgroundColor:'#f5f8fb90'}} className={`preloader flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
                <Image className="loader-element animate__animated animate__jackInTheBox" src={ApplicationIcons.Icons.kitTrackIcon} height={80} />
            </div>
            :null
        );

    }
}

PostProcess.propTypes = {
    show:PropTypes.bool,
}

export default React.forwardRef((props, ref) => (
    <PostProcess {...props} ref={ref} />
));